import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default class extends Controller {
  connect() {
    const splide = new Splide(this.element, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      fixedWidth: 500,
      pause: false,
      arrows: false,
      pagination: false,
      perPage: 10,
      autoScroll: {
        speed: 0.3,
      },
    });

    splide.mount( { AutoScroll } );
  }
}
